import * as Sentry from '@sentry/angular'
import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class SentryService {

    loginUser(username, name): void {
        Sentry.setUser({
            name: name,
            id: username,
        })
    }

    logoutUser(): void {
        Sentry.setUser({})
    }

    captureCustomException(text): void {
        Sentry.captureException(new Error(text))
    }
}
